import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/system';
import './ServicesList.css';

const ServiceCard = styled(Card)({
    padding: '15px',
    borderRadius: '5px',
    background: "#F8F8F8",
    boxShadow: "none",
    height: "100%",
    transition: 'background-color 0.3s, color 0.3s ',
});


function extractTextFromHTML(html) {
    // Create a temporary DOM element
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html; // Parse the HTML string
    return tempDiv.textContent || tempDiv.innerText || ''; // Extract the text content
}


const ServicesList = ({ url, data }) => {

    const [servicesData, setServicesData] = useState([]);

    useEffect(() => {
        if (data?.content?.objects && Array.isArray(data?.content?.objects)) {
            setServicesData(data?.content?.objects);
        } else {
            console.warn("No services found or 'objects' is not an array.");
        }
    }, [data]);

    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className="services-page">
            <div className='services-container container'>
                <div className='Header'>
                    <h2>Filtrix Services</h2>
                    <span>{extractTextFromHTML(data?.page_description)}</span>
                </div>

                <Grid container spacing={4} className='services-card-container'>
                    {servicesData.map((service, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            key={index}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <ServiceCard style={{ backgroundColor: hoveredIndex === index ? '#000' : '#F8F8F8', color: hoveredIndex === index ? '#fff' : 'inherit' }}>
                                <CardContent>
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: hoveredIndex === index ? '#fff' : '#000',
                                            fontFamily: 'Poppins, sans-serif',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                        }}
                                    >
                                        <img src={`${url}${service.icon}`} alt="icon" style={{ marginRight: '12px' }} />
                                        {service.name}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        style={{
                                            marginTop: '8px',
                                            color: hoveredIndex === index ? '#9b9b9b' : 'rgba(0, 0, 0, 0.6)', // Red on hover
                                            fontSize: '14px',
                                            fontStyle: 'normal',
                                            transition: 'color 0.3s',
                                        }}
                                    >
                                        {service.description}
                                    </Typography>
                                </CardContent>
                            </ServiceCard>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
};

export default ServicesList;
